module.exports = __webpack_public_path__ + "img/map.ace6fd81.png";